export { default as useRoutePaths } from './useRoutePaths'
